// extracted by mini-css-extract-plugin
export default {"peta":"SideMaps_peta__IRQ0u","contact-us":"SideMaps_contact-us__dWbWd","footer-link":"SideMaps_footer-link__dnHwQ"};